import { EPromotionType } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PromotionTypeInfo';
import { EServiceId } from '../../../../types/reducers/publishTerms';

export function mapPromotionType(promotionType: EPromotionType): EServiceId {
  switch (promotionType) {
    case EPromotionType.Standard:
      return EServiceId.paid;
    case EPromotionType.Top:
      return EServiceId.top;
    case EPromotionType.Premium:
      return EServiceId.premium;
    default:
      throw new Error('Unknown promotion type');
  }
}
